export default __webpack_public_path__ + "static/media/frame-wood-smiley.8f865214.png";